exports.isLessThanMinimumPoint = function(vm) {
  return (
    vm.point > 0 && vm.point < vm.item.bid_points + vm.item.minimum_increment
  );
};

exports.showErrorMessageMinimumPoint = function(vm) {
  vm.errorMessage = `กรุณาเพิ่มการประมูลอย่างน้อย ${vm.item.minimum_increment} คะแนน`;
};
